import { render, staticRenderFns } from "./GerenciaScreenReporteBodega.vue?vue&type=template&id=1fb818c4"
import script from "./GerenciaScreenReporteBodega.vue?vue&type=script&lang=js"
export * from "./GerenciaScreenReporteBodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports